import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-checkmark',
  templateUrl: './checkmark.component.html',
  styleUrl: './checkmark.component.css',
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class CheckmarkComponent {
  @Input() checked = false;
  @Input() text = '';
}
